export function trim(value){
    return value.replace(/\s/g, '');
}